import { render, staticRenderFns } from "./playground.vue?vue&type=template&id=5b65cbee"
import script from "./playground.vue?vue&type=script&lang=js"
export * from "./playground.vue?vue&type=script&lang=js"
import style0 from "./playground.vue?vue&type=style&index=0&id=5b65cbee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports